/* eslint-disable prettier/prettier */
import {
  PAPEL4,
  PAPEL3,
  PAPEL2,
  PAPEL1,
  PAPELDEFAULT,
  PAPEL5,
  PAPEL6,
  PAPEL7,
  PAPEL8,
  PAPEL9
} from 'src/utils/rbac/papeis';
import { portalName, primaryColor, showPgReports, showPgReportsPapel2, showChatIA, showPainelFinanceiro, showRelatorioIqvia } from './config';
import {
  Trello as TrelloIcon,
  PieChart as PieChartIcon,
  CheckCircle as CheckCircleIcon,
  Settings as SettingsIcon
} from 'react-feather';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import EmojiEventsOutlinedIcon from '@material-ui/icons/EmojiEventsOutlined';
import BeenhereOutlinedIcon from '@material-ui/icons/BeenhereOutlined';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';
import ApartmentIcon from '@material-ui/icons/Apartment';
import StoreIcon from '@material-ui/icons/Store';
import BallotIcon from '@material-ui/icons/Ballot';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import TableChartIcon from '@material-ui/icons/TableChart';
import TuneIcon from '@material-ui/icons/Tune';
import StorageIcon from '@material-ui/icons/Storage';
import RateReviewIcon from '@material-ui/icons/RateReview';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';

import { svgIcons } from '../src/utils/icons';
import { v1 as uuidv1 } from 'uuid';
import { Chat } from '@material-ui/icons';

export const APP_VERSION = '0.1.0';
export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: 'LIGHT'
};
export const BRAND_PRIMARY_COLOR = primaryColor;

export const PTBR_TABLE_TRANSLATE = {
  pagination: {
    labelDisplayedRows: '{from}-{to} de {count}',
    labelRowsSelect: 'Linhas',
    labelRowsPerPage: 'Linhas por página',
    firstTooltip: 'Primeira página',
    previousTooltip: 'Página anterior',
    nextTooltip: 'Próxima página',
    lastTooltip: 'Última página'
  },
  toolbar: {
    nRowsSelected: '{0} linha(s) selecionada(s)',
    searchTooltip: 'Pesquisar',
    searchPlaceholder: 'Pesquisar'
  },
  header: {
    actions: 'Ações'
  },
  body: {
    emptyDataSourceMessage: 'Lista vazia',
    addTooltip: 'Adicionar',
    deleteTooltip: 'Deletar',
    editTooltip: 'Editar',
    filterRow: {
      filterTooltip: 'Filtrar'
    },
    editRow: {
      deleteText: 'Tem certeza de que deseja deletar este item?',
      cancelTooltip: 'Cancelar',
      saveTooltip: 'Salvar'
    }
  }
};

export const styleTable = {
  headerStyle: {
    borderLeft: '1px solid #f2f2f2',
    borderRight: '1px solid #f2f2f2',
    color: '#404040'
  },
  cellStyle: {
    borderLeft: '1px solid #f2f2f2',
    borderRight: '1px solid #f2f2f2'
  }
};

export const meses = [
  { id: 1, name: 'Janeiro' },
  { id: 2, name: 'Fevereiro' },
  { id: 3, name: 'Março' },
  { id: 4, name: 'Abril' },
  { id: 5, name: 'Maio' },
  { id: 6, name: 'Junho' },
  { id: 7, name: 'Julho' },
  { id: 8, name: 'Agosto' },
  { id: 9, name: 'Setembro' },
  { id: 10, name: 'Outubro' },
  { id: 11, name: 'Novembro' },
  { id: 12, name: 'Dezembro' }
];

export const statusEmpresa = [
  { id: 1, status: 'Ativa' },
  { id: 2, status: 'Inativa' }
];

// `atribuivelPor` define quais papéis podem atribuir este nível a um usuário nos formulários de criação/edição.
export const todosNiveisAcesso = [
  {
    id: 1,
    nivel: PAPELDEFAULT,
    nome: '',
    atribuivelPor: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL9]
  },
  {
    id: 2,
    nivel: PAPEL1,
    nome: 'Visualização',
    atribuivelPor: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL9]
  },
  {
    id: 3,
    nivel: PAPEL6,
    nome: 'SubGestão',
    atribuivelPor: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL9]
  },
  {
    id: 4,
    nivel: PAPEL2,
    nome: 'Gestão',
    atribuivelPor: [PAPEL3, PAPEL4, PAPEL5, PAPEL9]
  },
  {
    id: 5,
    nivel: PAPEL7,
    nome: 'Integração',
    atribuivelPor: [PAPEL4, PAPEL9]
  },
  {
    id: 6,
    nivel: PAPEL8,
    nome: 'Replicação',
    atribuivelPor: [PAPEL4, PAPEL9]
  },
  {
    id: 7,
    nivel: PAPEL3,
    nome: 'Administração',
    atribuivelPor: [PAPEL4, PAPEL5, PAPEL9]
  },
  {
    id: 8,
    nivel: PAPEL5,
    nome: 'Administração WL',
    atribuivelPor: [PAPEL4, PAPEL9]
  },
  {
    id: 9,
    nivel: PAPEL9,
    nome: 'Comercial',
    atribuivelPor: [PAPEL4, PAPEL9]
  },
  {
    id: 10,
    nivel: PAPEL4,
    nome: 'Super Admin',
    atribuivelPor: ['']
  }
];

export const valoresDefaultCurvaAbc = [
  { id: 'A', categoria: 'A', porcentagem: 60 },
  { id: 'B', categoria: 'B', porcentagem: 30 },
  { id: 'C', categoria: 'C', porcentagem: 10 }
];

export const valorDefaultParametroD = {
  id: 'D',
  categoria: 'D',
  dias: 90
};

export const iconArray: { name: string; icon: string; id: string }[] = [];
let id: any = uuidv1();

for (const iconName in svgIcons) {
  if (Object.hasOwnProperty.call(svgIcons, iconName)) {
    iconArray.push({ name: iconName, icon: iconName, id: id.toString() });
    id++;
  }
}

export const IMG_ERROR = '/static/img-error.svg';
export const LOGO_ERROR = '/static/logo-error.svg';
export const IMG_FUNDO = '/static/login-bg.svg';

// ------ nomes atributos salvos banco de dados
export const ticketMedio = 'ticket';
export const numeroCupons = 'cupons';

export const sectionsMenu = [
  {
    subheader: 'Relatórios',
    allowedRoles: [PAPEL1, PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL8, PAPEL9],
    items: []
  },
  ...(showChatIA
    ? [
      {
        subheader: 'IA',
        allowedRoles: [PAPEL4],
        items: [
          {
            title: 'Chat IA',
            icon: Chat,
            href: '/chat-ia',
            allowedRoles: [PAPEL4]
          }
        ]
      }
    ]
    : []),
  {
    subheader: 'Configurações',
    allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL7, PAPEL8, PAPEL9],
    items: [
      {
        title: 'Usuários',
        icon: GroupAddOutlinedIcon,
        href: '/gerenciar-usuarios/lista',
        allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL9]
      },
      {
        title: 'Grupos de Controle',
        icon: FindInPageOutlinedIcon,
        href: '/grupos-controle',
        allowedRoles: [PAPEL3, PAPEL4, PAPEL5, PAPEL7, PAPEL8, PAPEL9]
      },
      ...(showPgReports
        ? [
          {
            title: 'Construtor de Relatórios',
            icon: TableChartIcon,
            href: '/contrutorRelatorios',
            allowedRoles: [
              ...(showPgReportsPapel2 ? [PAPEL2] : []),
              PAPEL3,
              PAPEL4,
              PAPEL5,
              PAPEL9
            ]
          }
        ]
        : []),

      {
        title: 'Fatores de Correção',
        icon: CheckCircleIcon,
        href: '/fator',
        allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9],
        items: [
          {
            title: 'Novo Fator de Correção',
            href: '/fator/nova',
            allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9]
          },
          {
            title: 'Acessa Lista',
            href: '/fator/gerenciar',
            allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9]
          }
        ]
      },
      {
        title: 'Configurações',
        icon: SettingsIcon,
        href: '/configuracoes',
        allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9],
        items: [
          {
            title: 'Curva ABC',
            href: '/configuracoes/curvaAbc',
            allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9]
          },
          {
            title: 'Excesso de Estoque',
            href: '/configuracoes/estoque',
            allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9]
          },
          {
            title: 'Índices de Referência',
            href: '/configuracoes/indicesReferencia',
            allowedRoles: [PAPEL2, PAPEL3, PAPEL4, PAPEL5, PAPEL6, PAPEL9]
          }
        ]
      },
      {
        title: 'Parâmetros BI',
        icon: DashboardIcon,
        href: '/parametrosBi',
        allowedRoles: [PAPEL4, PAPEL7, PAPEL8, PAPEL9],
        items: [

          {
            title: 'Parâmetros de Replicação',
            href: '/parametrosBi/parametrosReplicacao',
            allowedRoles: [PAPEL4, PAPEL8, PAPEL9]
          },
          {
            title: 'Nova Versão Modelos PBI',
            href: '/parametrosBi/novaVersao',
            allowedRoles: [PAPEL4]
          }
        ]
      },
      {
        title: 'Parâmetros Globais',
        icon: BeenhereIcon,
        href: '/parametrosGlobais',
        allowedRoles: [PAPEL4, PAPEL9, PAPEL5]
      },
      ...(showRelatorioIqvia
        ? [
          {
            title: 'Validação N3 IQVIA',
            icon: RateReviewIcon,
            href: '/validacao-iqvia',
            allowedRoles: [PAPEL4]
          }
        ]
        : []),
      ...(showPainelFinanceiro
        ? [
          {
            title: 'Informações Financeiras',
            icon: LocalAtmIcon,
            href: '/infoFinanceiras',
            allowedRoles: [PAPEL4]
          }
        ]
        : [])
    ]
  },
  {
    subheader: 'Administração',
    allowedRoles: [PAPEL3, PAPEL4, PAPEL5, PAPEL7, PAPEL8, PAPEL9],
    items: [

      {
        title: 'Empresas',
        icon: ApartmentIcon,
        href: '/gerenciar-empresas/lista',
        allowedRoles: [PAPEL3, PAPEL4, PAPEL5, PAPEL7, PAPEL8, PAPEL9]
      },
      {
        title: 'Classificações de Loja',
        icon: StoreIcon,
        href: '/classificacoes-loja',
        allowedRoles: [PAPEL4, PAPEL5, PAPEL9]
      },
      {
        title: 'Motivos Status Empresa',
        icon: BallotIcon,
        href: '/motivosStatusEmpresa',
        allowedRoles: [PAPEL4, PAPEL9]
      },
      {
        title: 'Gestão de Relatórios',
        icon: TrelloIcon,
        allowedRoles: [PAPEL4, PAPEL9],
        items: [
          {
            title: 'Categorias de Painéis',
            href: '/paineis/categorias',
            allowedRoles: [PAPEL4, PAPEL9]
          },
          {
            title: 'Painéis',
            href: '/paineis',
            allowedRoles: [PAPEL4, PAPEL9]
          }
        ]
      },
      {
        title: 'Solicitações',
        icon: AssignmentIcon,
        allowedRoles: [PAPEL3, PAPEL4, PAPEL5, PAPEL9],
        items: [
          {
            title: 'Nova ativação',
            href: '/solicitacoes/novaAtivacao',
            allowedRoles: [PAPEL3, PAPEL4, PAPEL5, PAPEL9]
          },
          {
            title: 'Suporte',
            href: '/solicitacoes/suporte',
            allowedRoles: [PAPEL3, PAPEL4, PAPEL5, PAPEL9]
          }
        ]
      }
    ]
  }
];

export const statusPowerBiEmbedded = [
  { id: 1, status: 'Ativo' },
  { id: 2, status: 'Inativo' }
];

export const atrNecessariosPbiRelatorio = ['pbiWorkspaceId', 'pbiReportId', 'pbiDatasetId'];

export enum Status {
  Criado = 'Aguardando verificação do email, e definição da senha pelo usuário',
  Incompleto = 'Usuário com informações pendentes',
  Ativado = 'Ativo, verificado e configurado'
}

export const tempoIntervaloEmail = 60;

// valores iniciais atributo 'parametrizacaoIntegracao' tela parâmetros integração
export const valoresDefaultParametrosIntegracao = {
  dsn: '',
  urlPlanilhaFinanceiraBi: '',
  urlPlanilhaFinanceiraPublica: '',
  urlPlanilhaStatusClientesBi: '',
  urlPlanilhaStatusClientesPublica: '',

  host: '',
  nomeOuCaminhoBanco: '',
  porta: 0,
  senha: '',
  usuario: '',

  portal: portalName || '',
  quantidadeLinhas: 0,
  tipoBanco: '',
  tipoDestino: 's3',
  workers: 1,
  sources: {
    pgfarma: {
      status: false,
      ambiente: 'dev',
      fonteVariavel: 'pgloader' as 'padrao' | 'pgloader' | 'adhoc'
    },
    iqvia: {
      status: false,
      ambiente: 'dev',
      fonteVariavel: 'padrao' as 'padrao' | 'pgloader' | 'adhoc'
    },
    closeup: {
      status: false,
      ambiente: 'dev',
      fonteVariavel: 'padrao' as 'padrao' | 'pgloader' | 'adhoc'
    }
  },
  cloudflare: {
    tunnelCommand: '',
    tunnelName: '',
    tunnelId: '',
    etapas: {
      cloudflaredInstalado: false,
      connectorValidado: false,
      rotaConfigurada: false
    }
  },
  anydesk: {
    idMaquina: '',
    senhaMaquina: '',
    descricaoMaquina: ''
  }
};

// utilizado na tela de Pametros Integracao
export const tiposDestino = [
  { id: 1, tipo: 'Azure', valor: 'azure' },
  { id: 2, tipo: 'AWS', valor: 's3' },
  { id: 3, tipo: 'Ambos', valor: 'ambos' }
];

// utilizado na tela de Pametros Integracao
export const tiposBanco = [
  { id: 1, tipo: 'MySQL' },
  { id: 2, tipo: 'PostgreSQL' },
  { id: 3, tipo: 'SQLServer' },
  { id: 4, tipo: 'Oracle' },
  { id: 5, tipo: 'Firebird' },
  { id: 6, tipo: 'MongoDB' }
];

export const valoresDefaultIndicesReferencia = [
  {
    nome: 'Taxa de Crescimento',
    indice: 'taxadeCrescimento',
    id: uuidv1(),
    valor: 0
  },
  {
    nome: 'Excelência em Reposição (SLA)',
    indice: 'excelenciaemReposicao',
    id: uuidv1(),
    valor: 0
  },
  {
    nome: 'Índice Margem Bruta',
    indice: 'indiceMargemBruta',
    id: uuidv1(),
    valor: 0
  },
  {
    nome: 'Estoque em Custo',
    indice: 'estoqueemCusto',
    id: uuidv1(),
    valor: 0
  },
  {
    nome: '% Curva D',
    indice: 'curvaD',
    id: uuidv1(),
    valor: 0
  }
];

export const dialetos = ['mysql', 'postgresql', 'sqlite', 'sql', 'plsql'] as const;

export const deliveryOptions = [
  'Telefone',
  'Whatsapp',
  'iFood',
  'Farmácias APP',
  'E-commerce',
  'Outros'
];

export const nomesQuerysPorSource: Record<string, string[]> = {
  pgfarma: [
    'tb_clientes',
    'tb_codigo_barras',
    'tb_compras',
    'tb_empresas',
    'tb_estoque',
    'tb_fornecedores',
    'tb_funcionarios',
    'tb_produtos',
    'tb_vendas'
  ],
  iqvia: [
    'tb_clientes_iqvia',
    'tb_compras_iqvia',
    'tb_compras_devolucoes_cancelamentos_iqvia',
    'tb_estabelecimentos_iqvia',
    'tb_estoque_iqvia',
    'tb_fornecedores_iqvia',
    'tb_laboratorios_pbm_iqvia',
    'tb_pacientes_iqvia',
    'tb_planos_saude_iqvia',
    'tb_prescricoes_iqvia',
    'tb_produtos_iqvia',
    'tb_profissionais_saude_iqvia',
    'tb_vendas_iqvia',
    'tb_vendas_devolucoes_cancelamentos_iqvia'
  ],
  closeup: [
    'tb_empresas_closeup',
    'tb_clientes_closeup',
    'tb_produtos_closeup',
    'tb_vendas_closeup'
  ]
};

export const redeOptions = ['Associativismo', 'Licenciamento', 'Franquia'];

export const filtrosSqlOptions = [
  { value: '=', label: 'Igual (=)' },
  { value: '<>', label: 'Diferente (<>)' },
  { value: '>', label: 'Maior que (>)' },
  { value: '>=', label: 'Maior ou igual (>=)' },
  { value: '<', label: 'Menor que (<)' },
  { value: '<=', label: 'Menor ou igual (<=)' },
  { value: 'LIKE', label: 'Contém (LIKE)' },
  { value: 'NOT LIKE', label: 'Não contém (NOT LIKE)' }
];

export const filtrosSqlPorTipoDado: Record<string, string[]> = {
  string: ['=', '<>', 'LIKE', 'NOT LIKE'],
  number: ['=', '>', '>=', '<', '<='],
  date: ['=', '>', '>=', '<', '<='],
  boolean: ['=', '<>']
};

export const tiposIngestao = [
  { value: 'pgloader', label: 'PGLOADER' },
  { value: 'api', label: 'API' },
  { value: 'ftp', label: 'FTP' }
];

export const tiposIngestaoWeb = ['api', 'ftp'];

export const opcoesAmbiente = [
  { value: 'administracao', label: 'Administração' },
  { value: 'individual', label: 'Individual' },
  { value: 'individual_nova_versao', label: 'Individual Nova Versão' },
  { value: 'vitrine', label: 'Vitrine' },
  { value: 'centralizado', label: 'Centralizado' },
  { value: 'mercado', label: 'Mercado' }
];

export const origemMsgChat = 'plataforma';

export const dreTabData = [
  { Conta: '1.1 VENDA BRUTA', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '1.1' },
  { Conta: '1.2 DESCONTO', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '1.2' },
  { Conta: '1.3 VENDA LÍQUIDA', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '1.3' },
  { Conta: '1.4 CMV', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '1.4' },
  { Conta: '1.5 LUCRO BRUTO', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '1.5' },
  { Conta: '2.1 DESPESAS OPERACIONAIS VARIÁVEIS', Grupo1: '2. LUCRO OPERACIONAL', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '2.1' },
  { Conta: '2.2 DESPESAS OPERACIONAIS FIXAS', Grupo1: '2. LUCRO OPERACIONAL', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '2.2' },
  { Conta: '2.3 LUCRO OPERACIONAL', Grupo1: '2. LUCRO OPERACIONAL', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '2.3' },
  { Conta: '3.1 RECEITAS NÃO OPERACIONAIS', Grupo1: '3. LUCRO LÍQUIDO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '3.1' },
  { Conta: '3.2 DESPESAS NÃO OPERACIONAIS', Grupo1: '3. LUCRO LÍQUIDO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '3.2' },
  { Conta: '3.3 LUCRO LÍQUIDO', Grupo1: '3. LUCRO LÍQUIDO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'COMPETÊNCIA', ID: '3.3' },
  { Conta: '1.1 RECEITA LÍQUIDA FINANCEIRA OPERACIONAL', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '1.1' },
  { Conta: '1.2 FORNECEDORES DE MERCADORIA PAGOS EFETIVAMENTE', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '1.2' },
  { Conta: '1.3 LUCRO BRUTO', Grupo1: '1. LUCRO BRUTO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '1.3' },
  { Conta: '2.1 DESPESAS OPERACIONAIS VARIÁVEIS', Grupo1: '2. LUCRO OPERACIONAL', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '2.1' },
  { Conta: '2.2 DESPESAS OPERACIONAIS FIXAS', Grupo1: '2. LUCRO OPERACIONAL', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '2.2' },
  { Conta: '2.3 LUCRO OPERACIONAL', Grupo1: '2. LUCRO OPERACIONAL', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '2.3' },
  { Conta: '3.1 RECEITAS NÃO OPERACIONAIS', Grupo1: '3. LUCRO LÍQUIDO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '3.1' },
  { Conta: '3.2 DESPESAS NÃO OPERACIONAIS', Grupo1: '3. LUCRO LÍQUIDO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '3.2' },
  { Conta: '3.3 LUCRO LÍQUIDO', Grupo1: '3. LUCRO LÍQUIDO', Grupo2: '0. ACUMULADO DO PERÍODO', Regime: 'FLUXO DE CAIXA', ID: '3.3' }
];